import { css } from 'lit';

export const styles = css`:host{--item-hover-background: var(--ig-tabs-item-hover-background, hsla(var(--ig-gray-100), 0.5));--item-active-background: var(--ig-tabs-item-active-background, hsla(var(--ig-gray-100), 0.5))}`;
